import { render, staticRenderFns } from "./LandingChainContact.vue?vue&type=template&id=6adaf4b5&scoped=true"
import script from "./LandingChainContact.vue?vue&type=script&lang=js"
export * from "./LandingChainContact.vue?vue&type=script&lang=js"
import style0 from "./LandingChainContact.vue?vue&type=style&index=0&id=6adaf4b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adaf4b5",
  null
  
)

export default component.exports